import React from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  FormGroup,
  Input,
  CustomInput,
  UncontrolledTooltip
} from "reactstrap";
import { useTranslation } from "react-i18next";

const SwitchEdit = (props) => {
  const { t } = useTranslation();
  console.log(props.edit);
  const checkAvailableParent = () => {
    if (props.switches.length < 2) return false;
    const response = props.switches.filter(s => s.id !== props.id && (!s.parent || s.parent === "0") && s.name);
    if (response.length < 1) return false;
    return true;
  }
  const updateParts = () => {
    return props.switchConfirmEdit(props.id, props.edit.command, props.edit.autoOn, props.edit.name, props.edit.isSAM, props.edit.autoOff, props.edit.isAutoNight, props.edit.parent, props.edit.isAutoDay, props.edit.isReverted, props.edit.isCyclic);
  }
  const formatParentSelect = () => {
    const parseSwitches = props.switches.filter(s => s.id !== props.id && (!s.parent || s.parent === "0") && s.name);
    return (
      <Input className="selectParent" name="select" type="select" onChange={(event) => props.switchPreEdit(props.id, 'parent', event.target.value)} value={props.edit.parent}>
        <option value="0">Disable</option>
        {
          parseSwitches.map(s => {
            return((s.id !== props.id && (!s.parent || s.parent === "0")) && <option value={s.id}>
              {s.name}
            </option>)
          })
        }
      </Input>
    );
  };
  return (
      <Col xl="4" lg="6" md="6" xs="12">
        <Card>
          <CardBody className="sw_body">
            <div className="sw_btns"><i className="sw_icons tim-icons icon-check-2" onClick={() => props.switchCancelEditMode(props.id)}/></div>
            <Row className="sw_desc_top">
              <Col xs="6">
                <div className="name">{t('name')}</div>
                <FormGroup>
                  <Input placeholder={t('name')} value={props.edit.name || ''} onChange={(e) => props.switchPreEdit(props.id, 'name', e.target.value)} onBlur={updateParts} type="text" />
                </FormGroup>
              </Col>
              <Col xs="6">
                  <div className="desc_title">{t('command')}</div>
                  <div className="desc_body"><FormGroup>
                    <Input placeholder={t('command')} value={props.edit.command || ''} onChange={(e) => props.switchPreEdit(props.id, 'command', e.target.value)} onBlur={updateParts} disabled={props.edit.parent !== "0"} type="text" />
                  </FormGroup></div>
                </Col>
            </Row>
              <Row>
                <Col xs="6" className="sw_option">
                  <div className="desc_title">{t('autoNight')}</div>
                </Col>
                <Col xs="6" className="sw_sam" id="autoNight">
                  <CustomInput
                    type="switch"
                    id={`switch-${props.id}-night`}
                    checked={props.edit.isAutoNight}
                    onChange={(e) => props.switchPreEdit(props.id, 'isAutoNight', e.target.checked)}
                    className="sw_checkbox"
                    disabled={props.edit.parent !== "0" || props.edit.isAutoDay || props.edit.isCyclic.enabled}
                  />
                </Col>
                <Col xs="6" className="sw_option">
                  <div className="desc_title">{t('autoDay')}</div>
                </Col>
                <Col xs="6" className="sw_sam" id="autoDay">
                  <CustomInput
                    type="switch"
                    id={`switch-${props.id}-day`}
                    checked={props.edit.isAutoDay}
                    onChange={(e) => props.switchPreEdit(props.id, 'isAutoDay', e.target.checked)}
                    className="sw_checkbox"
                    disabled={props.edit.parent !== "0" || props.edit.isAutoNight || props.edit.isCyclic.enabled}
                  />
                </Col>
                <Col xs="6" className="sw_option">
                  <div className="desc_title">{t('reverted')}</div>
                </Col>
                <Col xs="6" className="sw_sam" id="reverted">
                  <CustomInput
                    type="switch"
                    id={`switch-${props.id}-reverted`}
                    checked={props.edit.isReverted}
                    onChange={(e) => props.switchPreEdit(props.id, 'isReverted', e.target.checked)}
                    className="sw_checkbox"
                    disabled={props.edit.parent !== "0" || props.edit.isCyclic.enabled}
                  />
                </Col>
                <Col xs="6" className="sw_option">
                    <div className="desc_title">{t('samsite')}</div>
                </Col>
                <Col xs="6" className="sw_sam" id="sw_sam">
                    <CustomInput
                      type="switch"
                      id={`switch-${props.id}`}
                      checked={props.edit.isSAM}
                      disabled={props.edit.parent !== "0" || props.edit.isCyclic.enabled}
                      onChange={(e) => props.switchPreEdit(props.id, 'isSAM', e.target.checked)}
                      className="sw_checkbox"
                    />
                </Col>
                <Col xs="6" className="sw_option">
                  <div className="desc_title">{t('autoOn')}</div>
                </Col>
                <Col xs="6" id="autoOn" className="d-flex">
                  <div className="desc_body"><FormGroup>
                    <Input
                      disabled={props.edit.parent !== "0" || props.edit.isCyclic.enabled || props.edit.autoOff}
                      value={props.edit.autoOn || 0}
                      id={`autoOn-${props.id}`}
                      onChange={(e) => props.switchPreEdit(props.id, 'autoOn', e.target.value)}
                      onBlur={updateParts}
                      type="number"
                    />
                  </FormGroup></div>
                </Col>
                <Col xs="6" className="sw_option">
                  <div className="desc_title">{t('autoOff')}</div>
                </Col>
                <Col xs="6" id="autoOff" className="d-flex">
                  <div className="desc_body"><FormGroup>
                    <Input
                      value={props.edit.autoOff || 0}
                      id={`autoOff-${props.id}`}
                      onChange={(e) => props.switchPreEdit(props.id, 'autoOff', e.target.value)}
                      onBlur={updateParts}
                      type="number"
                      disabled={props.edit.parent !== "0" || props.edit.isCyclic.enabled || props.edit.autoOn}
                    />
                  </FormGroup></div>
                </Col>
                <Col xs="6" className="sw_option">
                  <div className="desc_title">{t('cyclic')}</div>
                </Col>
                <Col xs="6" className="sw_sam" id="cyclic">
                  <CustomInput
                    type="switch"
                    id={`switch-${props.id}-cyclic`}
                    checked={props.edit.isCyclic.enabled}
                    onChange={(e) => props.switchPreEdit(props.id, 'isCyclic.enabled', e.target.checked)}
                    className="sw_checkbox"
                    disabled={props.edit.parent !== "0" || props.edit.isAutoDay || props.edit.isAutoNight || props.edit.isReverted}
                  />
                </Col>
                {props.edit.isCyclic.enabled && <><Col xs="6" className="sw_option">
                  <div className="desc_title">{t('cyclicOn')}</div>
                </Col>
                <Col xs="6" id="cyclicOn" className="d-flex">
                  <div className="desc_body"><FormGroup>
                    <Input
                      disabled={props.edit.parent !== "0" || props.edit.isAutoNight || props.edit.isAutoNight || props.edit.isReverted}
                      value={props.edit.isCyclic.on || 10}
                      id={`cyclicOn-${props.id}`}
                      onChange={(e) => props.switchPreEdit(props.id, 'isCyclic.on', e.target.value)}
                      onBlur={updateParts}
                      type="number"
                      min={10}
                      max={7200}
                    />
                  </FormGroup></div>
                </Col></>}
                {props.edit.isCyclic.enabled && <><Col xs="6" className="sw_option">
                  <div className="desc_title">{t('cyclicOff')}</div>
                </Col>
                <Col xs="6" id="cyclicOff" className="d-flex">
                  <div className="desc_body"><FormGroup>
                    <Input
                      disabled={props.edit.parent !== "0" || props.edit.isAutoNight || props.edit.isAutoNight || props.edit.isReverted}
                      value={props.edit.isCyclic.off || 10}
                      id={`cyclicOff-${props.id}`}
                      onChange={(e) => props.switchPreEdit(props.id, 'isCyclic.off', e.target.value)}
                      onBlur={updateParts}
                      type="number"
                      min={10}
                      max={7200}
                    />
                  </FormGroup></div>
                </Col></>}
                {(checkAvailableParent() || props.edit.parent !== "0") && <>
                  <Col xs="6" className="sw_option">
                    <div className="desc_title">{t('parent')}</div>
                  </Col>
                  <Col xs="6" id="parent" className="d-flex">
                    <div className="desc_body">
                      <FormGroup>
                        {formatParentSelect()}
                      </FormGroup>
                    </div>
                  </Col>
                </>}
                {props.userPlan < 3 && <UncontrolledTooltip delay={2} placement="right" target="sw_sam">{t('featureNotAvailable')}</UncontrolledTooltip>}
                {props.userPlan < 2 && <UncontrolledTooltip delay={2} placement="right" target="autoOn">{t('featureNotAvailable')}</UncontrolledTooltip>}
                {props.userPlan < 3 && <UncontrolledTooltip delay={2} placement="right" target="autoNight">{t('featureNotAvailable')}</UncontrolledTooltip>}
                {props.userPlan < 3 && <UncontrolledTooltip delay={2} placement="right" target="autoDay">{t('featureNotAvailable')}</UncontrolledTooltip>}
                {props.userPlan < 3 && <UncontrolledTooltip delay={2} placement="right" target="reverted">{t('featureNotAvailable')}</UncontrolledTooltip>}
                {props.userPlan < 3 && <UncontrolledTooltip delay={2} placement="right" target="cyclic">{t('featureNotAvailable')}</UncontrolledTooltip>}
                {props.userPlan < 3 && <UncontrolledTooltip delay={2} placement="right" target="autoOff">{t('featureNotAvailable')}</UncontrolledTooltip>}
            </Row>
          </CardBody>
        </Card>
      </Col>
  );
};

export default SwitchEdit;